<template>
  <div class="unordered-container">
    <div class="unordered"> -- unordered-- </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Unordered",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.unordered-container {
  width: 100%;
  heigth: 100%;
}
</style>